// 自动生成于 2026-08-26（第二版），数据来源：用户更新后的完整风格判定 Excel 表
// 全部维度已改为干净标签词汇（骨架/皮肉/臀/胸/面部6项），配合两层组合词匹配算法
// 请勿手改数值，如需更新请重新导出 style_matrix.json 后重跑生成脚本

export interface StyleInfo {
  cn: string
  en: string
  family: string
  familyEn: string
  element: string
}

export const STYLES: StyleInfo[] = [
  { cn: '浪漫型风格', en: 'Romantic', family: '浪漫型', familyEn: 'Romantic', element: '水' },
  { cn: '戏剧浪漫型', en: 'Theatlical romantic', family: '浪漫型', familyEn: 'Romantic', element: '水' },
  { cn: '柔软少年型', en: 'Soft gamine', family: '少年型', familyEn: 'Gamine', element: '金' },
  { cn: '少年型', en: 'Gamine', family: '少年型', familyEn: 'Gamine', element: '金' },
  { cn: '戏剧少年型', en: 'Flamboyant Gamine', family: '少年型', familyEn: 'Gamine', element: '金' },
  { cn: '柔软经典型', en: 'Soft Classic', family: '经典型', familyEn: 'Classic', element: '土' },
  { cn: '经典型', en: ' Classic', family: '经典型', familyEn: 'Classic', element: '土' },
  { cn: '戏剧经典型', en: 'Dramatic Classic', family: '经典型', familyEn: 'Classic', element: '土' },
  { cn: '浪漫自然型', en: 'Soft Natural', family: '自然型', familyEn: 'Natural', element: '木' },
  { cn: '自然型', en: 'Natural', family: '自然型', familyEn: 'Natural', element: '木' },
  { cn: '戏剧自然型', en: 'Flamboyant Natural', family: '自然型', familyEn: 'Natural', element: '木' },
  { cn: '浪漫戏剧型', en: 'Soft Dramatic', family: '戏剧型', familyEn: 'Dramatic', element: '火' },
  { cn: '戏剧型', en: 'Dramatic', family: '戏剧型', familyEn: 'Dramatic', element: '火' },
]

// exact   = 精确分档相等匹配（身高）
// alias   = UI 选项通过别名表做子串匹配（四肢、手脚——这两项表格仍是旧格式，未清洗）
// combo   = 组合词多选，'+' '、' '/' 均视为 AND 分隔符，family 层任意词命中即可，variant 层要求完整覆盖
// orSingle= 单选，但格子内出现多个候选词时，命中任意一个即可（如嘴唇 '中厚/小厚' 二选一都算）
export type MatchType = 'exact' | 'alias' | 'combo' | 'orSingle'

export interface StyleDimension {
  id: string
  category: string
  subcategory: string
  label: string
  weight: number
  matchType: MatchType
  valuesByStyle: Record<string, string>
}

export const DIMENSIONS: StyleDimension[] = [
  {
    id: 'boneScale',
    category: '体型：70%',
    subcategory: '骨骼：50%',
    label: '骨架：S（圆/角/匀/宽/窄）/M（圆/角/匀/宽/窄）/L（圆/角/匀/宽/窄）',
    weight: 0.08,
    matchType: 'combo',
    valuesByStyle: {
      '浪漫型风格': 'S+圆',
      '戏剧浪漫型': 'S+匀',
      '柔软少年型': 'S+角',
      '少年型': 'S+角',
      '戏剧少年型': 'S+角+宽',
      '柔软经典型': 'M',
      '经典型': 'M',
      '戏剧经典型': 'M+角',
      '浪漫自然型': 'L',
      '自然型': 'L',
      '戏剧自然型': 'L+宽',
      '浪漫戏剧型': 'L',
      '戏剧型': 'L',
    },
  },
  {
    id: 'height',
    category: '体型：70%',
    subcategory: '骨骼：50%',
    label: '身高：<160/160-165/165-170/>170',
    weight: 0.07,
    matchType: 'exact',
    valuesByStyle: {
      '浪漫型风格': '<155',
      '戏剧浪漫型': '<155',
      '柔软少年型': '155-160',
      '少年型': '155-160',
      '戏剧少年型': '155-160',
      '柔软经典型': '160-165',
      '经典型': '160-165',
      '戏剧经典型': '160-165',
      '浪漫自然型': '165-170',
      '自然型': '165-170',
      '戏剧自然型': '165-170',
      '浪漫戏剧型': '>170',
      '戏剧型': '>170',
    },
  },
  {
    id: 'shoulder',
    category: '体型：70%',
    subcategory: '骨骼：50%',
    label: '肩：圆/直/宽/匀/溜/方/尖',
    weight: 0.07,
    matchType: 'combo',
    valuesByStyle: {
      '浪漫型风格': '圆+溜',
      '戏剧浪漫型': '圆+方',
      '柔软少年型': '溜+尖',
      '少年型': '溜+尖',
      '戏剧少年型': '溜+方',
      '柔软经典型': '圆+溜',
      '经典型': '圆',
      '戏剧经典型': '圆+方+尖',
      '浪漫自然型': '方+尖+宽',
      '自然型': '方+宽',
      '戏剧自然型': '方+宽+尖',
      '浪漫戏剧型': '宽',
      '戏剧型': '宽+尖+方',
    },
  },
  {
    id: 'waist',
    category: '体型：70%',
    subcategory: '骨骼：50%',
    label: '腰：细/直/匀/宽/长/短',
    weight: 0.07,
    matchType: 'combo',
    valuesByStyle: {
      '浪漫型风格': '细',
      '戏剧浪漫型': '细',
      '柔软少年型': '直+匀',
      '少年型': '直',
      '戏剧少年型': '直',
      '柔软经典型': '匀+短',
      '经典型': '匀',
      '戏剧经典型': '匀+短+直',
      '浪漫自然型': '细+匀+长',
      '自然型': '直+宽',
      '戏剧自然型': '直+宽',
      '浪漫戏剧型': '宽+直',
      '戏剧型': '宽+直',
    },
  },
  {
    id: 'limb',
    category: '体型：70%',
    subcategory: '骨骼：50%',
    label: '四肢：短/偏短/适中/偏长/长',
    weight: 0.07,
    matchType: 'alias',
    valuesByStyle: {
      '浪漫型风格': '偏短',
      '戏剧浪漫型': '适中',
      '柔软少年型': '短',
      '少年型': '适中',
      '戏剧少年型': '偏长',
      '柔软经典型': '适中/偏短',
      '经典型': '适中',
      '戏剧经典型': '适中/偏长',
      '浪漫自然型': '适中/偏短',
      '自然型': '偏长',
      '戏剧自然型': '偏长',
      '浪漫戏剧型': '长',
      '戏剧型': '长',
    },
  },
  {
    id: 'handFoot',
    category: '体型：70%',
    subcategory: '骨骼：50%',
    label: '手脚：肉（小/偏小/适中/偏大/大）/适中（小/偏小/适中/偏大/大）/瘦（小/偏小/适中/偏大/大）',
    weight: 0.07,
    matchType: 'alias',
    valuesByStyle: {
      '浪漫型风格': '肉/偏小',
      '戏剧浪漫型': '肉/偏小',
      '柔软少年型': '瘦/小',
      '少年型': '瘦/小',
      '戏剧少年型': '瘦/偏大',
      '柔软经典型': '肉质适中/偏小',
      '经典型': '肉质适中/大小适中',
      '戏剧经典型': '肉质适中/偏大',
      '浪漫自然型': '肉质适中/大小适中',
      '自然型': '肉质适中/大小偏大',
      '戏剧自然型': '肉质偏瘦/大小偏大',
      '浪漫戏剧型': '肉质偏瘦/大',
      '戏剧型': '肉质偏瘦/大',
    },
  },
  {
    id: 'bodyShape',
    category: '体型：70%',
    subcategory: '骨骼：50%',
    label: '体格：X/O/A/H/S/V',
    weight: 0.07,
    matchType: 'combo',
    valuesByStyle: {
      '浪漫型风格': 'X型',
      '戏剧浪漫型': 'X型',
      '柔软少年型': 'X型、O型、A型',
      '少年型': 'X型、A型',
      '戏剧少年型': 'A型、X型',
      '柔软经典型': 'X型、A型、O型',
      '经典型': 'A型',
      '戏剧经典型': 'A型、H型',
      '浪漫自然型': 'V型、O型、X型',
      '自然型': 'V型、H型',
      '戏剧自然型': 'V型',
      '浪漫戏剧型': 'H型、V型',
      '戏剧型': 'H型、V型',
    },
  },
  {
    id: 'fleshTexture',
    category: '体型：70%',
    subcategory: '皮相：20%',
    label: '皮肉：软肉/紧实/健壮/松肉/适中/肌肉',
    weight: 0.07,
    matchType: 'combo',
    valuesByStyle: {
      '浪漫型风格': '软肉',
      '戏剧浪漫型': '软肉',
      '柔软少年型': '软肉',
      '少年型': '紧实+健壮',
      '戏剧少年型': '紧实+肌肉',
      '柔软经典型': '适中',
      '经典型': '适中',
      '戏剧经典型': '紧实+肌肉',
      '浪漫自然型': '软肉+松肉',
      '自然型': '紧实+肌肉',
      '戏剧自然型': '紧实+健壮',
      '浪漫戏剧型': '紧实+适中',
      '戏剧型': '紧实+健壮',
    },
  },
  {
    id: 'hip',
    category: '体型：70%',
    subcategory: '皮相：20%',
    label: '臀：凸/扁平/适中/有肉',
    weight: 0.06,
    matchType: 'combo',
    valuesByStyle: {
      '浪漫型风格': '凸+有肉',
      '戏剧浪漫型': '凸+有肉',
      '柔软少年型': '凸',
      '少年型': '适中',
      '戏剧少年型': '扁平',
      '柔软经典型': '有肉',
      '经典型': '适中',
      '戏剧经典型': '扁平',
      '浪漫自然型': '有肉',
      '自然型': '扁平',
      '戏剧自然型': '扁平',
      '浪漫戏剧型': '有肉',
      '戏剧型': '扁平',
    },
  },
  {
    id: 'chest',
    category: '体型：70%',
    subcategory: '皮相：20%',
    label: '胸：凸//扁平/适中/大胸/小胸',
    weight: 0.07,
    matchType: 'combo',
    valuesByStyle: {
      '浪漫型风格': '凸',
      '戏剧浪漫型': '凸',
      '柔软少年型': '凸',
      '少年型': '扁平+小胸',
      '戏剧少年型': '扁平+小胸',
      '柔软经典型': '适中',
      '经典型': '适中',
      '戏剧经典型': '扁平',
      '浪漫自然型': '大胸',
      '自然型': '扁平+大胸',
      '戏剧自然型': '扁平',
      '浪漫戏剧型': '扁平',
      '戏剧型': '扁平',
    },
  },
  {
    id: 'lip',
    category: '面部：30%',
    subcategory: '面部特诊',
    label: '嘴：厚（大厚/中厚/小厚）/薄（大薄/中薄/小薄）',
    weight: 0.05,
    matchType: 'orSingle',
    valuesByStyle: {
      '浪漫型风格': '中厚',
      '戏剧浪漫型': '中厚/小厚',
      '柔软少年型': '小厚',
      '少年型': '中薄',
      '戏剧少年型': '中厚',
      '柔软经典型': '中厚',
      '经典型': '中厚',
      '戏剧经典型': '中厚',
      '浪漫自然型': '中薄',
      '自然型': '中薄',
      '戏剧自然型': '中薄',
      '浪漫戏剧型': '大厚',
      '戏剧型': '大薄',
    },
  },
  {
    id: 'cheek',
    category: '面部：30%',
    subcategory: '面部特诊',
    label: '两颊：丰满（肉/角/中）/适中（肉/角/中）/紧实（肉/角/中）',
    weight: 0.05,
    matchType: 'combo',
    valuesByStyle: {
      '浪漫型风格': '肉/丰满',
      '戏剧浪漫型': '角/丰满',
      '柔软少年型': '肉/适中',
      '少年型': '肉/适中',
      '戏剧少年型': '中/紧实',
      '柔软经典型': '肉/适中',
      '经典型': '中/适中',
      '戏剧经典型': '角/适中',
      '浪漫自然型': '中/紧实',
      '自然型': '中/紧实',
      '戏剧自然型': '中/紧实',
      '浪漫戏剧型': '肉/紧实',
      '戏剧型': '肉/紧实',
    },
  },
  {
    id: 'cheekbone',
    category: '面部：30%',
    subcategory: '面部特诊',
    label: '颧：大（圆/尖/凸/角/匀）/适中（圆/尖/凸/角/匀）/小（圆/尖/凸/角/匀）',
    weight: 0.05,
    matchType: 'combo',
    valuesByStyle: {
      '浪漫型风格': '小/圆',
      '戏剧浪漫型': '小/角',
      '柔软少年型': '小/角',
      '少年型': '小/角',
      '戏剧少年型': '小/尖',
      '柔软经典型': '适中/中',
      '经典型': '适中/中',
      '戏剧经典型': '适中/角',
      '浪漫自然型': '大/适中',
      '自然型': '大/角',
      '戏剧自然型': '大/凸',
      '浪漫戏剧型': '大/角',
      '戏剧型': '大/凸',
    },
  },
  {
    id: 'chin',
    category: '面部：30%',
    subcategory: '面部特诊',
    label: '下巴：圆（大/小/适中）/尖（大/小/适中）/匀/（大/小/适中）凸（大/小/适中）/方（大/小/适中）',
    weight: 0.05,
    matchType: 'combo',
    valuesByStyle: {
      '浪漫型风格': '圆/小',
      '戏剧浪漫型': '尖/小',
      '柔软少年型': '小',
      '少年型': '方/小',
      '戏剧少年型': '方/小',
      '柔软经典型': '匀/小',
      '经典型': '匀/适中',
      '戏剧经典型': '匀/适中',
      '浪漫自然型': '凸/适中',
      '自然型': '凸/适中',
      '戏剧自然型': '凸/大',
      '浪漫戏剧型': '凸/大',
      '戏剧型': '凸/大',
    },
  },
  {
    id: 'eyes',
    category: '面部：30%',
    subcategory: '面部特诊',
    label: '眼睛：细小（圆/直/眼距近/眼距远）/小（圆/直/眼距近/眼距远）/中（圆/直/眼距近/眼距远）/大（圆/直/眼距近/眼距远）/超大（圆/直/眼距近/眼距远）',
    weight: 0.05,
    matchType: 'combo',
    valuesByStyle: {
      '浪漫型风格': '大/圆',
      '戏剧浪漫型': '大/圆',
      '柔软少年型': '中/圆',
      '少年型': '大/圆',
      '戏剧少年型': '大/圆',
      '柔软经典型': '中/圆',
      '经典型': '中',
      '戏剧经典型': '中',
      '浪漫自然型': '小/直',
      '自然型': '小/眼距远',
      '戏剧自然型': '大/圆或者小/直',
      '浪漫戏剧型': '大',
      '戏剧型': '细小/直',
    },
  },
  {
    id: 'nose',
    category: '面部：30%',
    subcategory: '面部特诊',
    label: '鼻子：大（圆/棱/凸/匀）/中（圆/棱/凸/匀）/小（圆/棱/凸/匀）',
    weight: 0.05,
    matchType: 'combo',
    valuesByStyle: {
      '浪漫型风格': '小/圆',
      '戏剧浪漫型': '小/棱',
      '柔软少年型': '小/匀',
      '少年型': '小/棱',
      '戏剧少年型': '小/棱',
      '柔软经典型': '中/匀',
      '经典型': '中/匀',
      '戏剧经典型': '中/匀',
      '浪漫自然型': '中/凸',
      '自然型': '大/凸',
      '戏剧自然型': '大/凸',
      '浪漫戏剧型': '大/棱',
      '戏剧型': '大/凸/棱',
    },
  },
]

export const TOTAL_WEIGHT = DIMENSIONS.reduce((s, d) => s + d.weight, 0)
